var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLightBulkheadType01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,12.4c-2.4-0.1-4.3-2.2-4.1-4.6c0.1-2.2,1.9-4,4.1-4.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 8,
    y1: 12.4,
    x2: 8,
    y2: 3.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 8,
    cy: 8,
    rx: 4.5,
    ry: 4.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 6.2,
    y1: 4,
    x2: 6.2,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 10.4,
    y1: 4.3,
    x2: 10.4,
    y2: 11.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 7.3,
    y1: 3.8,
    x2: 7.3,
    y2: 12.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4.3,
    y1: 5.4,
    x2: 4.3,
    y2: 10.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11.6,
    y1: 5.4,
    x2: 11.6,
    y2: 10.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 8.6,
    y1: 12.4,
    x2: 8.6,
    y2: 3.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4.7,
    y1: 5,
    x2: 4.7,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 11.2,
    y1: 4.9,
    x2: 11.2,
    y2: 11.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLightBulkheadType01);
export default __webpack_public_path__ + "static/media/ExternalLight-BulkheadType-01.c38500792de8288b8a6426bd6a6b5c7a.svg";
export { ForwardRef as ReactComponent };